module.exports = __webpack_public_path__ + "img/product28-shichang.26eff3bc.svg";